<script>
import { conciliacaoClient } from '../../libs/conciliacao-client'
import FaturamentoGuiasTable from './conciliacao_manual_pagamento_lote/FaturamentoGuiasTable.vue'
import ConciliacaoManualTopBar from './conciliacao_manual_pagamento_lote/ConciliacaoManualTopBar.vue'
import PagamentoGuiasTable from './conciliacao_manual_pagamento_lote/PagamentoGuiasTable.vue'
import FaturamentoItemsTable from './conciliacao_manual_pagamento_lote/FaturamentoItemsTable.vue'
import PagamentoItemsTable from './conciliacao_manual_pagamento_lote/PagamentoItemsTable.vue'
import GuiaAssociadaDialog from './conciliacao_manual_pagamento_lote/GuiaAssociadaDialog.vue'
import ConciliacaoManualBottombar from './conciliacao_manual_pagamento_lote/ConciliacaoManualBottombar.vue'

export default {
  props: {
    loteId: String,
    pagamentoId: String
  },
  components: {
    ConciliacaoManualTopBar,
    PagamentoGuiasTable,
    FaturamentoGuiasTable,
    FaturamentoItemsTable,
    PagamentoItemsTable,
    GuiaAssociadaDialog,
    ConciliacaoManualBottombar
},
  data () {
    return {
      pagamentoGuiasSelected: [],
      pagamentoGuiasFilterQuery: {},
      pagamentoGuiasOrderQuery: {},
      faturamentoGuiasSelected: [],
      faturamentoGuiasFilterQuery: {},
      faturamentoGuiasOrderQuery: [],
      faturamentoGuiaSearchIsNull: true,
      pagamentoItemsSelected: [],
      pagamentoItemsFilterQuery: {},
      pagamentoItemsOrderQuery: {},
      faturamentoItemsSelected: [],
      faturamentoItemsFilterQuery: {},
      faturamentoItemsOrderQuery: {},
      guiasAssociadasDialopOpen: false,
      filteredGuiasAssociadas: {},
      snackbar: {
        open: false,
        message: null,
        action: null,
        color: 'success'
      }
    }
  },
  methods: {
    reloadPage () {
      this.$asyncComputed.getPagamentoLoteById.update()
      this.$asyncComputed.getPagamentoGuiasPage.update()
      this.$asyncComputed.getPagamentoItemsPage.update()
      this.$asyncComputed.getFaturamentoGuiasPage.update()
      this.$asyncComputed.getFaturamentoGuiasSuggestions.update()
      this.$asyncComputed.getFaturamentoItensPage.update()
      this.$asyncComputed.getConciliacaoGuias.update()
      this.$asyncComputed.getConciliacaoItems.update()
      this.pagamentoGuiasSelected = []
      this.faturamentoGuiasSelected = []
    },
    delayedReloadPage () {
      setTimeout(() => {
        this.reloadPage()
      }, 5000);
    },
    mapSortDirection (sortQuery) {
      return sortQuery.map(item => `${item.direction === 'asc' ? '' : '-'}${item.value}` )
    },
    selectedPagamentoGuiasChange (value) {
      this.pagamentoGuiasSelected = value
      this.pagamentoItemsSelected = this.pagamentoItemsSelected.filter(item => this.selectedPagamentoGuiaIds.includes(item.pagamentoGuiaId))

      const pagamentoGuiasSelectedIds = value.map(pagamentoGuia => pagamentoGuia.id)
      const faturamentoGuiasAssociadasIds = this.conciliacaoGuiasSelected
        .filter(conciliacaoGuia => pagamentoGuiasSelectedIds.includes(conciliacaoGuia.pagamentoGuiaId))
        .map(conciliacaoGuia => conciliacaoGuia.faturamentoGuiasId)
        .flat() || []

      this.$watch(
        () => this.getFaturamentoGuiasSuggestions,
        (faturamentoGuiasSuggestions) => {
          const autoSelectFaturamentoGuias = faturamentoGuiasSuggestions.filter(faturamentoGuia => faturamentoGuiasAssociadasIds.includes(faturamentoGuia.id))
          this.faturamentoGuiasSelected = autoSelectFaturamentoGuias;
        }
      )
    },
    pagamentoGuiaFilterChange (query) {
      this.pagamentoGuiasFilterQuery = query
      this.$asyncComputed.getPagamentoGuiasPage.update()
    },
    pagamentoGuiaOrderQueryChange (value) {
      this.pagamentoGuiasOrderQuery = this.mapSortDirection(value)
    },
    selectedFaturamentoGuiasChange (value) {
      this.faturamentoGuiasSelected = value

      var faturamentoGuiaIds = this.faturamentoGuiasSelected.map(faturamentoGuia => faturamentoGuia.id)
      this.faturamentoItemsSelected = this.faturamentoItemsSelected.filter(faturamentoItem => faturamentoGuiaIds.includes(faturamentoItem.guiaId))
    },
    faturamentoGuiaFilterChange (query) {
      this.faturamentoGuiasFilterQuery = query
      this.faturamentoGuiaSearchIsNull = Object.values(this.faturamentoGuiasFilterQuery).every(value => {
        return value === null
      })
      this.$asyncComputed.getFaturamentoGuiasPage.update()
    },
    faturamentoGuiaOrderQueryChange (value) {
      this.faturamentoGuiasOrderQuery = this.mapSortDirection(value)
      this.$asyncComputed.getFaturamentoGuiasSuggestions.update()
      this.$asyncComputed.getFaturamentoGuias.update()
    },
    selectedPagamentoItemsChange (value) {
      this.pagamentoItemsSelected = value
    },
    pagamentoItemFilterChange (query) {
      this.pagamentoItemsFilterQuery = query
      this.$asyncComputed.getPagamentoItemsPage.update()
    },
    pagamentoItemOrderQueryChange (value) {
      this.pagamentoItemsOrderQuery = this.mapSortDirection(value)
      this.$asyncComputed.getPagamentoItemsPage.update()
    },
    selectedFaturamentoItemsChange (value) {
      this.faturamentoItemsSelected = value
    },
    faturamentoItemFilterChange (query) {
      this.faturamentoItemsFilterQuery = query
      this.$asyncComputed.getFaturamentoItensPage.update()
    },
    faturamentoItemOrderQueryChange (value) {
      this.faturamentoItemsOrderQuery = this.mapSortDirection(value)
      this.$asyncComputed.getFaturamentoItensPage.update()
    },
    guiaAssociadaChipClick (value) {
      const guiasAssociadasChip = value
      const filteredPagamentoGuias = this.pagamentoGuias
        .filter(pagamentoGuia => guiasAssociadasChip.pagamentoGuiasId.includes(pagamentoGuia.id))
        .map(pagamentoGuia => pagamentoGuia.id)
      const filteredFaturamentoGuias = this.faturamentoGuias
        .filter(faturamentoGuia => guiasAssociadasChip.faturamentoGuiasId.includes(faturamentoGuia.id))
        .map(faturamentoGuia => faturamentoGuia.id)

      this.filteredGuiasAssociadas = {
        filteredPagamentoGuias,
        filteredFaturamentoGuias
      }

      this.guiasAssociadasDialopOpen = true
    },
    async clickConciliacaoAutomatica (value) {
      await conciliacaoClient.conciliacaoExecucao.createConciliacaoExecucaoBatch(value)

      this.reloadPage()
    },
    async clickDesassociar (value) {
      const conciliacaoGuias = value
      const deletaConciliacaoGuias = conciliacaoGuias
        .filter(conciliacaoGuia => conciliacaoGuia.faturamentoGuiasId?.length !== 0)
        .flat()

      try {
        const data = deletaConciliacaoGuias
        await conciliacaoClient.conciliacaoGuia.deleteConciliacaoGuias({ data })

        this.snackbar.message = 'Desassociação realizada.'
        this.snackbar.action = 'Desassociar'
        this.snackbar.open = true
        this.snackbar.color = 'success'

        this.reloadPage()
      } catch (error) {
        this.snackbar.message = error.response.data.detail
        this.snackbar.action = 'Desassociar'
        this.snackbar.open = true
        this.snackbar.color = 'error'

        this.reloadPage()
      }

    },
    async clickDesconciliar (value) {
      const command = {
        pagamentoId: this.pagamentoId,
        data: [{
          pagamentoLoteId: this.loteId,
          ...value
        }]
      }

      try {
        await conciliacaoClient.pagamento.desconciliar(command)

        this.snackbar.message = 'Desconciliação realizada.'
        this.snackbar.action = 'Desconciliar'
        this.snackbar.open = true
        this.snackbar.color = 'success'

        this.reloadPage()
      } catch (error) {
        this.snackbar.message = error.response.data.detail
        this.snackbar.action = 'Desconciliar'
        this.snackbar.open = true
        this.snackbar.color = 'error'

        this.reloadPage()
      }
    },
    async clickAssociar () {
      const associarGuias = this.selectedFaturamentoGuiaIds
        ?.map(faturamentoGuiaId => this.selectedPagamentoGuiaIds
          .map(pagamentoGuiaId => {
            return {
              pagamentoGuiaId,
              faturamentoGuiaId
            }
          }))
        .flat()

      try {
        const data = associarGuias
        await conciliacaoClient.conciliacaoGuia.createConciliacaoGuias({ data })

        this.snackbar.message = 'Associação de guias realizada.'
        this.snackbar.action = 'Associar'
        this.snackbar.open = true
        this.snackbar.color = 'success'

        this.reloadPage()
      } catch (error) {
        this.snackbar.message = error.response.data.detail
        this.snackbar.action = 'Associar'
        this.snackbar.open = true
        this.snackbar.color = 'error'

        this.reloadPage()
      }
    },
    async clickConciliar () {
      const data = {
        itens: this.pagamentoItemsSelected.map(pagamentoItem => (
          this.faturamentoItemsSelected.map(faturamentoItem => ({
            pagamentoItemId: pagamentoItem.id,
            faturamentoItemId: faturamentoItem.id
          }))
        )).flat()
      }
      try {
        await conciliacaoClient.conciliacaoItens.createConciliacaoItens(data)

        this.snackbar.message = 'Conciliação realizada.'
        this.snackbar.action = 'Conciliação'
        this.snackbar.open = true
        this.snackbar.color = 'success'
        this.pagamentoItemsSelected = []
        this.faturamentoItemsSelected = []

        this.reloadPage()
      } catch (error) {
        this.snackbar.message = error.response.data.detail
        this.snackbar.action = 'Conciliar'
        this.snackbar.open = true
        this.snackbar.color = 'error'

        this.reloadPage()
      }
    },
    async clickMarcarRecurso (value) {
      const marcarRecursoQuery = {
        ...value,
        tipoRegistro: "recurso",
      }
      await conciliacaoClient.pagamentoItem.updatePagamentoItensTipoRegistro(marcarRecursoQuery)
      this.$asyncComputed.getPagamentoItemsPage.update()
    },
    async clickInvalidar (value) {
      const invalidarQuery = {
        ...value,
        itemValido: false
      }
      await conciliacaoClient.pagamentoItem.updatePagamentoItensItemValido(invalidarQuery)
      this.$asyncComputed.getPagamentoItemsPage.update()
    },
    setPagamentoItensQueryConciliacaoCount () {
      this.pagamentoItemsFilterQuery = {
        conciliacaoItensCountEq: 0,
        conciliacaoItensCountGt: undefined
      }
    }
  },
  computed: {
    pagamentoLote () {
      return this.getPagamentoLoteById || {}
    },
    pagamentoGuias () {
      return this.getPagamentoGuiasPage?.data || []
    },
    selectedPagamentoGuiaIds () {
     return this.pagamentoGuiasSelected.map(pagamentoGuia => pagamentoGuia.id)
    },
    faturamentoGuias () {
      const faturamentoGuiasSuggetionsIds = (this.getFaturamentoGuiasSuggestions || []).map(faturamentoGuia => faturamentoGuia.id)
      const faturamentoGuiasPage = this.faturamentoGuiasSearch.filter(faturamentoGuia => !faturamentoGuiasSuggetionsIds.includes(faturamentoGuia.id))
      const faturamentoGuias = (this.getFaturamentoGuiasSuggestions || []).concat(faturamentoGuiasPage || [])
      return [...new Set(faturamentoGuias)]
    },
    selectedFaturamentoGuiaIds () {
      return this.faturamentoGuiasSelected.map(faturamentoGuia => faturamentoGuia.id)
    },
    faturamentoGuiasSearch () {
      if (this.faturamentoGuiaSearchIsNull) {
        return []
      } else {
        return this.getFaturamentoGuiasPage?.data || []
      }
    },
    faturamentoItems () {
      return this.getFaturamentoItensPage?.data || []
    },
    pagamentoItems () {
      return this.getPagamentoItemsPage?.data || []
    },
    selectedPagamentoItensIds () {
      return this.pagamentoItemsSelected.map(pagamentoItem => pagamentoItem.id)
    },
    guiasConciliacaoAutomatica () {
      return this.pagamentoGuiasSelected.filter(guia => guia.status === 'conciliacaoAutomatica').map(guia => guia.id)
    },
    conciliacaoGuias () {
      return this.getConciliacaoGuias?.data || []
    },
    conciliacaoItems () {
      return this.getConciliacaoItems?.data || []
    },
    conciliacaoGuiasSelected () {
      const guiasAssociadas = this.selectedPagamentoGuiaIds.map((pagamentoGuiaId, index) => {
        return {
          index: index,
          pagamentoGuiaId: pagamentoGuiaId,
          faturamentoGuiasId: this.conciliacaoGuias
            .filter(conciliacaoGuia => conciliacaoGuia.pagamentoGuiaId === pagamentoGuiaId)
            .map(conciliacaoGuia => conciliacaoGuia.faturamentoGuia.id)
        }
      })
      return guiasAssociadas || []
    },
    selectedPagamentoItemsConciliados () {
      const selectedPagamentoItemsConciliados = this.pagamentoItemsSelected.map((pagamentoItem) => {
        const faturamentoItemsId = this.conciliacaoItems
          .filter(conciliacaoItem => conciliacaoItem.pagamentoItemId === pagamentoItem.id)
          .map(conciliacaoItem => conciliacaoItem.faturamentoItemId)
        const pagamentoItemsId = this.conciliacaoItems
          .filter(conciliacaoItem => faturamentoItemsId.includes(conciliacaoItem.faturamentoItemId))
          .map(conciliacaoItem => conciliacaoItem.pagamentoItemId)
        return {
          pagamentoItemsId: pagamentoItemsId,
          faturamentoItemsId: faturamentoItemsId
        }
      })
      return selectedPagamentoItemsConciliados
    },
    selectedFaturamentoItemsConciliados () {
      const selectedFaturamentoItemsConciliados = this.faturamentoItemsSelected.map((faturamentoItem) => {
        const pagamentoItemsId = this.conciliacaoItems
          .filter(conciliacaoItem => conciliacaoItem.faturamentoItemId === faturamentoItem.id)
          .map(conciliacaoItem => conciliacaoItem.pagamentoItemId)
        const faturamentoItemsId = this.conciliacaoItems
          .filter(conciliacaoItem => pagamentoItemsId.includes(conciliacaoItem.pagamentoItemId))
          .map(conciliacaoItem => conciliacaoItem.faturamentoItemId)
        return {
          pagamentoItemsId: pagamentoItemsId,
          faturamentoItemsId: faturamentoItemsId
        }
      })
      return selectedFaturamentoItemsConciliados
    },
    conciliacaoItemsSelected () {
      const itemsConciliados = this.selectedPagamentoItemsConciliados.concat(this.selectedFaturamentoItemsConciliados)
      .filter(itemConciliado =>
      itemConciliado.pagamentoItemsId.length > 0 &&
      itemConciliado.faturamentoItemsId.length > 0)

      const itemsConciliadosFiltered = itemsConciliados.map((item, index) => {
        return {
          index: index,
          pagamentoItemsId: item.pagamentoItemsId,
          faturamentoItemsId: item.faturamentoItemsId
        }
      })

      return itemsConciliadosFiltered
    },
    guiasRegulares () {
      const filteredGuiasRegulares = this.pagamentoGuiasSelected?.filter(pagamentoGuia => pagamentoGuia?.isGuiaRegular === true)
      const hasSelectedGuiasRegulares = filteredGuiasRegulares?.length > 0

      if (hasSelectedGuiasRegulares){
        this.setPagamentoItensQueryConciliacaoCount()
      }

      return hasSelectedGuiasRegulares
    },
    isReloading () {
      const conciliacaoRodando = this.pagamentoLote.status === 'conciliacaoAutomatica'
      if (conciliacaoRodando) {
        this.delayedReloadPage()
        return conciliacaoRodando
      }
      return false
    }
  },
  asyncComputed: {
    getPagamentoLoteById: {
      get () {
        return conciliacaoClient.pagamentoLote.getPagamentoLoteById(
          this.loteId,
          {
            includePagamento: true,
            includeOperadoraAns: true,
            includePrestador: true
          }
        )
      }
    },
    getPagamentoGuiasPage: {
      get () {
        if (Object.keys(this.pagamentoGuiasFilterQuery).length === 0) {
          this.pagamentoGuiasFilterQuery = {
            guiasFinalizadas: false,
            guiasPendentes: true
          }
        }
        return conciliacaoClient.pagamentoGuia.getPagamentoGuiasPage({
          ...this.pagamentoGuiasFilterQuery,
          sorting: this.pagamentoGuiasOrderQuery,
          pagamentoLoteId: this.loteId,
          pageSize: 1000
        })
      }
    },
    getFaturamentoGuiasPage: {
      get () {
        if (this.faturamentoGuiaSearchIsNull) return []
        return conciliacaoClient.faturamentoGuia.getFaturamentoGuiasPage({
            ...this.faturamentoGuiasFilterQuery,
            sorting: this.faturamentoGuiasOrderQuery,
            includeCronograma: true,
            includeLote: true,
            pageSize: 1000
          })
      }
    },
    getFaturamentoGuiasSuggestions: {
      get () {
        return conciliacaoClient.faturamentoGuia.getFaturamentoGuiasSuggestions({
          pagamentoGuiaIds: this.selectedPagamentoGuiaIds,
          sorting: this.faturamentoGuiasOrderQuery,
          onlyPositiveValorGlosado: false,
        })
      }
    },
    getPagamentoItemsPage: {
      get () {
        if (this.pagamentoGuiasSelected.length === 0 ) return []
        else {
          return conciliacaoClient.pagamentoItem.getPagamentoItensPage({
            ...this.pagamentoItemsFilterQuery,
            sorting: this.pagamentoItemsOrderQuery,
            pagamentoLoteId: this.loteId,
            pagamentoGuiasId: this.selectedPagamentoGuiaIds,
            includeConciliacaoItens: true,
            pageSize: 1000
          })
        }
      }
    },
    getFaturamentoItensPage: {
      get () {
        if (this.faturamentoGuiasSelected.length === 0) return []
        else {
          return conciliacaoClient.faturamentoItem.getFaturamentoItensPage({
            ...this.faturamentoItemsFilterQuery,
            sorting: this.faturamentoItemsOrderQuery,
            guiaIds: this.selectedFaturamentoGuiaIds,
            includeConciliacaoItens: true,
            includeFaturamentoEquipes: true,
            pageSize: 1000
          })
        }
      }
    },
    getConciliacaoGuias: {
      get () {
        return conciliacaoClient.conciliacaoGuia.getConciliacaoGuiasPage({
          pagamentoLoteId: this.loteId,
          pageSize: 100,
          includeFaturamentoGuia: true
        })
      }
    },
    getConciliacaoItems: {
      get () {
        return conciliacaoClient.conciliacaoItens.getConciliacaoItensPage({
          pagamentoLoteId: this.loteId,
          pageSize: 1000
        })
      }
    }
  }
}
</script>

<template>
  <div style="width: 100;">
    <p class="font-weight-bold" v-if="isReloading">Carregando...</p>
    <ConciliacaoManualTopBar v-else :pagamentoLote="pagamentoLote" @reloadPage="reloadPage"/>
    <v-row  style="height: calc(50vh - 34px - 29px)" no-gutters>
      <v-col :cols="6">
        <PagamentoGuiasTable
          :pagamentoGuias="pagamentoGuias"
          :pagamentoLoteId="loteId"
          :selectedPagamentoGuias="pagamentoGuiasSelected"
          :conciliacaoGuiasSelected=conciliacaoGuiasSelected
          :someGuiaConciliacaoAutomatica="guiasConciliacaoAutomatica.length > 0"
          @selectedPagamentoGuiasChange="selectedPagamentoGuiasChange"
          @pagamentoGuiaFilterChange="pagamentoGuiaFilterChange"
          @pagamentoGuiaOrderQueryChange="pagamentoGuiaOrderQueryChange"
          @guiaAssociadaChipClick="guiaAssociadaChipClick"
          @clickDesassociar="clickDesassociar"
          @clickDesconciliar="clickDesconciliar"
          @clickConciliacaoAutomatica="clickConciliacaoAutomatica"
        />
      </v-col>
      <v-col :cols="6">
        <FaturamentoGuiasTable
          :faturamentoGuias="faturamentoGuias"
          :selectedFaturamentoGuias="faturamentoGuiasSelected"
          :conciliacaoGuiasSelected="conciliacaoGuiasSelected"
          :faturamentoItems="faturamentoItems"
          :conciliacaoItems="conciliacaoItems"
          @selectedFaturamentoGuiasChange="selectedFaturamentoGuiasChange"
          @faturamentoGuiaFilterChange="faturamentoGuiaFilterChange"
          @faturamentoGuiaOrderQueryChange="faturamentoGuiaOrderQueryChange"
          @guiaAssociadaChipClick="guiaAssociadaChipClick"
          @clickDesassociar="clickDesassociar"
          @clickDesconciliar="clickDesconciliar"
          @clickAssociar="clickAssociar"
        />
      </v-col>
    </v-row>
    <v-row style="height: calc(50vh - 34px - 29px)" no-gutters>
      <v-col :cols="6">
        <PagamentoItemsTable
          :pagamentoItems="pagamentoItems"
          :selectedPagamentoItems="pagamentoItemsSelected"
          :conciliacaoItemsSelected="conciliacaoItemsSelected"
          :conciliacaoItems="conciliacaoItems"
          :guiasConciliacaoAutomatica="guiasConciliacaoAutomatica"
          :guiasRegulares="guiasRegulares"
          @selectedPagamentoItemsChange="selectedPagamentoItemsChange"
          @pagamentoItemFilterChange="pagamentoItemFilterChange"
          @pagamentoItemOrderQueryChange="pagamentoItemOrderQueryChange"
          @clickMarcarRecurso="clickMarcarRecurso"
          @clickDesconciliar="clickDesconciliar"
          @clickInvalidar="clickInvalidar"
        />
      </v-col>
      <v-col :cols="6">
        <FaturamentoItemsTable
          :faturamentoItems="faturamentoItems"
          :selectedFaturamentoItems="faturamentoItemsSelected"
          :conciliacaoItemsSelected="conciliacaoItemsSelected"
          :conciliacaoItems="conciliacaoItems"
          @selectedFaturamentoItemsChange="selectedFaturamentoItemsChange"
          @faturamentoItemFilterChange="faturamentoItemFilterChange"
          @faturamentoItemOrderQueryChange="faturamentoItemOrderQueryChange"
          @clickDesconciliar="clickDesconciliar"
        />
      </v-col>
    </v-row>

    <div style="height: 48px">
      <ConciliacaoManualBottombar
        :selected-faturamento-itens="faturamentoItemsSelected"
        :selected-pagamento-itens="pagamentoItemsSelected"
        @clickConciliar="clickConciliar"
        :guiasConciliacaoAutomatica="guiasConciliacaoAutomatica"
      />
    </div>
    <v-dialog
      v-model="guiasAssociadasDialopOpen"
      @click:outside="() => guiasAssociadasDialopOpen = false"
      max-width="650px"
    >
      <GuiaAssociadaDialog
        :guiasAssociadas="filteredGuiasAssociadas"
      />
    </v-dialog>
    <v-snackbar v-model="snackbar.open" :color="snackbar.color">
      <b>{{ snackbar.action }}</b>
      <br/>
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>
